import { Outlet } from "react-router-dom";

export const MyProjectsLayout = () => {
  // Todo: Instantiate a CurrentProjectContextProvider here (see MyClimateActionsLayout)
  return <Outlet />;
};
